export default style => {
	switch (style) {
		case 'grounding-navy':
			return 'bg-grounding-navy text-caribbean'

		case 'light-blue':
			return 'bg-light-blue text-grounding-navy'

		case 'caribbean':
			return 'bg-caribbean text-grounding-navy'

		case 'tan':
			return 'bg-tan text-orange'

		default:
			return null
	}
}
